export const ATTRIBUTE_FIELD_FOR_ESTIMATES = 'Value';
export const ATTRIBUTE_FIELD_FOR_POPULATION = 'Population_at_risk';
export const ATTRIBUTE_FILED_FOR_UNCERTAINTY = 'Uncertainty_Interval';
export const RASTER_FIELD_FOR_ESTIMATES = '';
export const RASTER_FIELD_FOR_POPULATION = 'POP';
export const RASTER_FILED_FOR_UNCERTAINTY = 'UNCERT';

// Old fields
export let ATTRIBUTE_FIELD_ADMIN_0_NAME = 'ADM0';
export let ATTRIBUTE_FIELD_ADMIN_1_NAME = 'ADM1_NAME';
export let ATTRIBUTE_FIELD_ADMIN_2_NAME = 'ADM2_NAME';
export let ATTRIBUTE_FIELD_COUNTRY_CODE = 'DHSCC';
export let ATTRIBUTE_FIELD_SURVEY_TYPE = 'SurveyType';

// New fields
ATTRIBUTE_FIELD_ADMIN_0_NAME = 'adm0_name';
ATTRIBUTE_FIELD_ADMIN_1_NAME = 'adm1_name';
ATTRIBUTE_FIELD_ADMIN_2_NAME = 'adm2_name';
ATTRIBUTE_FIELD_COUNTRY_CODE = 'DHS_CountryCode';
